import { BUSINESS_MANAGEMENT_APIS } from "libs/apis/business-management.api";
import { USER_APIS } from "libs/apis/users.api";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";

const useBusinessManagement = () => {
  const navigate = useNavigate();
  const getBusinessList = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await BUSINESS_MANAGEMENT_APIS.getBusinessList(
      queryParams
    );
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      if (setFilters) {
        setFilters((prev: any) => ({
          ...prev,
          page: Number(pageNumber) + 1,
          limit: pageSize,
        }));
      }
      setTotalElements?.(totalElements);
    } else {
      setData([]);
      setTotalElements?.(0);
    }
  };

  const activateUser = async (userId: number) => {
    const response = await USER_APIS.activateUser(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const deactivateUser = async (userId: number) => {
    const response = await USER_APIS.deactivateUser(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const getBusinessDetailById = async (
    userId: number,
    setBusinessDetail: Function
  ) => {
    const response = await BUSINESS_MANAGEMENT_APIS.getBusinessDetailById(
      userId
    );
    const { status = false, data = {} } = response || {};
    if (status) {
      setBusinessDetail(data);
    }
  };

  return {
    getBusinessList,
    activateUser,
    deactivateUser,
    getBusinessDetailById,
  };
};

export default useBusinessManagement;
